import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { MaterialIcon } from '../ui/MaterialIcon';

// Calca BottomNav de components.jsx (Claude Design): pill cream detrás del ícono activo.
export const BottomNav: React.FC = () => {
  const user = useAuthStore((s) => s.user);
  const isWorker = user?.user_type === 'worker';

  const tabs = [
    { to: '/', label: 'Inicio', icon: 'home', end: true },
    ...(!isWorker ? [{ to: '/workers', label: 'Profesionales', icon: 'engineering', end: false }] : []),
    { to: '/my-jobs', label: 'Mis trabajos', icon: 'work', end: false },
    { to: '/profile', label: 'Perfil', icon: 'person', end: false },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-surface border-t border-outlineVarWarm pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-stretch justify-around">
        {tabs.map(({ to, label, icon, end }) => (
          <NavLink key={to} to={to} end={end} className="flex-1 flex flex-col items-center gap-1 pt-2 pb-1.5">
            {({ isActive }) => (
              <>
                <span className={`flex items-center justify-center w-14 h-8 rounded-2xl transition-colors ${isActive ? 'bg-cream' : ''}`}>
                  <MaterialIcon name={icon} size={22} fill={isActive} className={isActive ? 'text-primary-700' : 'text-onSurface-var'} />
                </span>
                <span className={`text-[11px] ${isActive ? 'font-bold text-onSurface' : 'font-medium text-onSurface-var'}`}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
